import React, { useState } from 'react';
import '../styles/common/Spinner.css';
import '../styles/ScoreList.css';
import MusicalNoteIcon from './icons/musical-note';
import CardMenu from './CardMenu';
import { PiMicrophoneStageFill } from "react-icons/pi";
import { useScores } from '../hooks/useScores';
import { filterScores, groupScoresByArtist, sortScores } from '../utils/scoreUtils';
import { useScoreFilters } from '../context/ScoreFiltersContext';
import { DEFAULT_SCORE_ARTIST, DEFAULT_SCORE_TITLE } from '../utils/scoreDefaults';

const ScoreList = ({ onSelectScore, userId }) => {
    const { scores, loading } = useScores({ userId });
    const { query, sortKey } = useScoreFilters();
    const [openMenuIndex, setOpenMenuIndex] = useState(null);

    const toggleMenu = (index) => {
        setOpenMenuIndex(openMenuIndex === index ? null : index);
    };

    const filteredScores = React.useMemo(() => {
      const filtered = filterScores(scores, query);
      return sortScores(filtered, sortKey);
    }, [scores, query, sortKey]);

    if (loading) {
        return (
            <div className="spinner-container">
                <div className="spinner"></div>
            </div>
        );
    }

    if (!filteredScores.length) {
        return <div>No scores found</div>;
    }

    const handleCardClick = (scoreId) => {
        if (typeof onSelectScore === 'function') {
            onSelectScore(scoreId);
        } else {
            window.location.href = `/?scoreid=${scoreId}`;
        }
    };

    const artistEntries = groupScoresByArtist(filteredScores);

    return (
        <div className="score-list-container">
            {artistEntries.map(([artistName, artistScores]) => (
              <section className="sidebar-artist-group" key={artistName}>
                <div className="sidebar-artist-header">
                  <PiMicrophoneStageFill className="sidebar-artist-icon" />
                  <span className="sidebar-artist-name">{artistName}</span>
                  <span className="sidebar-artist-count">{artistScores.length}</span>
                </div>
                <ul className="score-list">
                  {artistScores.map((score, index) => (
                    <li
                        key={score.scoreId}
                        className="score-list-item"
                        onClick={() => handleCardClick(score.scoreId)}
                        onMouseLeave={() => {
                          if (openMenuIndex === `${artistName}-${index}`) setOpenMenuIndex(null);
                        }}
                    >
                        <CardMenu
                            isOpen={openMenuIndex === `${artistName}-${index}`}
                            onToggle={(e) => {
                                e.stopPropagation();
                                toggleMenu(`${artistName}-${index}`);
                            }}
                            onDelete={(e) => e.stopPropagation()}
                        />
                        <span className="score-title">
                            <MusicalNoteIcon />
                            {score.title?.trim() || DEFAULT_SCORE_TITLE}
                        </span>
                        <span className="score-artist">{score.artist?.trim() || DEFAULT_SCORE_ARTIST}</span>
                        <span className="score-date">
                          {(score.updatedAt || score.score?.updatedAt || score.createdAt || "").slice(0, 10)}
                        </span>
                    </li>
                  ))}
                </ul>
              </section>
            ))}
        </div>
    );
};

export default ScoreList;
